// Queries
import receiptLogUnits from "./ReceiptLogUnitsQuery.gql";

export const Query = {
    receiptLogUnits,
};
